module.exports = __webpack_public_path__ + "img/2021jy_actMap.02d2b977.jpg";